import "./css/app.scss";
import "./ts/neto.js";


import lazyLoad from "./ts/lazyLoad";
import loadSprite from "./ts/loadSprite";
import slider from './ts/slider';
import descMenu from "./ts/descMenu";
import { addEvent , appHeight } from "./ts/utils";
import stickyHeader from "./ts/stickyHeader";
import readMore from "./ts/readmore";
import videos from "./ts/videos";
import accordian from "./ts/accordian";
import mobMenu from "./ts/mobMenu";
import tabs from "./ts/tabs";
import buyingQty from "./ts/buying";
import buyingQtyCart from "./ts/buyingCart";
import showHideProducts from "./ts/showHideProducts"
import showHideVideos from "./ts/showHideVideos";
import multiBuy from "./ts/multibuy";
import optionsAccordian from "./ts/optionsAccordian";
import multyPriceCalc from "./ts/multyPriceCalc";


addEvent();
appHeight();
loadSprite.init();
lazyLoad.init();
slider.init();
descMenu.init();
stickyHeader.init();
readMore.init();
videos.init();
accordian.init()
mobMenu.init()
tabs.init()
buyingQty.init()
buyingQtyCart.init()
multiBuy.init();
optionsAccordian.init();
showHideProducts.init()
showHideVideos.init()
multyPriceCalc.init()
